<template>
    <td-dialog
        :lockScroll="false"
        :title="$t(title)"
        :before-close="changeVerDialogColse"
        @cancel="changeVerDialogColse"
        :visible.sync="changeVerDialogVisible"
        width="1300px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-main>
            <el-form :inline="true" :model="versionForm" ref="versionForm">
                <el-form-item :label="$t('pgCommon.PUBLIC_VERSION_INFO')" prop="description">
                    <td-input v-model="versionForm.description"></td-input>
                </el-form-item>
                <el-form-item>
                    <td-button type="primary" @click="btnQuery">{{ $t('pgCommon.QUERY') }} </td-button>
                </el-form-item>
                <el-form-item>
                    <td-button type="button" @click="deleteBatch" :loading="deleteLoading">{{ $t('pgCommon.DELETE_BATCH') }} </td-button>
                </el-form-item>
            </el-form>
            <!-- 加载表格 -->
            <el-row>
                <el-col>
                    <td-table
                        :hasPageMemory="true"
                        height="400px"
                        :columns="columns"
                        :dataSource="tableData"
                        :pageSize="pageSize"
                        :currentPage="currentPage"
                        :total="total"
                        ref="versionList"
                        :hasMutiSelect="true"
                        :hasLoading="loading"
                        @handleSizeChange="handleSizeChange"
                        @currentChange="currentChange"
                        rowKey="deploymentId"
                    ></td-table>
                </el-col>
            </el-row>
        </el-main>
    </td-dialog>
</template>
<script>
import Api from './../assets/api.js';
export default {
    props: ['title', 'changeVerDialogVisible', 'row'],
    created() {
        this.btnQuery();
    },
    data() {
        return {
            versionForm: {
                description: ''
            },
            deleteLoading: false,
            tableData: [],
            pageSize: 10,
            currentPage: 1,
            total: '',
            columns: [
                {
                    prop: 'templateId',
                    label: this.$t('pgCommon.VERSION'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'deploymentTime',
                    align: 'center',
                    label: this.$t('pgCommon.DEPLOYMENT_TIME')
                },
                {
                    prop: 'description',
                    label: this.$t('pgCommon.PUBLIC_CONTENT')
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '90',
                    align: 'center',
                    render: (createElement, params) => {
                        if (params.row.suspensionState == 2) {
                            return createElement('div', [
                                createElement(
                                    'td-button',
                                    {
                                        props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.start(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.START')
                                ),
                                createElement(
                                    'td-button',
                                    {
                                        props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.delete(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.DELETE')
                                )
                            ]);
                        } else if (params.row.suspensionState == 1) {
                            return createElement('div', []);
                        }
                    }
                }
            ]
        };
    },
    methods: {
        //启用
        start(row) {
            this.$confirm(this.$t('pgMessage.START_TEMPLATE_TIPS'), this.$t('extendCommon.TIPS'), {
                confirmButtonText: window.vue.$t('extendCommon.CONFIRM'),
                cancelButtonText: window.vue.$t('extendCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = {
                        templateKey: row.templateKey,
                        templateId: row.templateId,
                        modelId: this.row.modelId,
                        deploymentId: row.deploymentId
                    };
                    Api.activateOldVersion(JSON.stringify(param), response => {
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            return;
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('service/activateOldVersion', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('pgCommon.SWITCH_SUCCESS'), type: 'success' });
                        this.callbackQuery();
                        this.$emit('callbackQuery');
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    // this.$log.error('extendInfo/btnDelete---- Fail')
                });
        },
        // 删除扩展组元素
        delete(row) {
            this.$confirm(this.$t('extendCommon.DELETE_INFO_TIPS'), this.$t('extendCommon.TIPS'), {
                confirmButtonText: window.vue.$t('extendCommon.CONFIRM'),
                cancelButtonText: window.vue.$t('extendCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let templateIds = [];
                    let deploymentIds = [];
                    templateIds.push(row.templateId);
                    deploymentIds.push(row.deploymentId);
                    let param = {
                        templateIds: templateIds,
                        deploymentIds: deploymentIds
                    };
                    Api.deleteVersions(JSON.stringify(param), response => {
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            return;
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('service/deleteVersions', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('extendCommon.DELETE_SUCCESS'), type: 'success' });
                        this.callbackQuery();
                        this.$emit('callbackQuery');
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    // this.$log.error('extendInfo/btnDelete---- Fail')
                });
        },
        // 批量删除
        deleteBatch() {
            this.deleteLoading = true;
            let items = this.$refs.versionList.getSelectAllRows();
            if (items == null || items.length === 0) {
                this.$message({ showClose: true, message: this.$t('extendCommon.PLEASE_SELECT'), type: 'warning' });
                this.deleteLoading = false;
                return;
            }
            this.$confirm(this.$t('extendCommon.DELETE_INFO_TIPS'), this.$t('extendCommon.TIPS'), {
                confirmButtonText: this.$t('extendCommon.CONFIRM'),
                cancelButtonText: this.$t('extendCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let templateIds = [];
                    let deploymentIds = [];
                    for (let i = 0; i < items.length; i++) {
                        templateIds.push(items[i].templateId);
                        deploymentIds.push(items[i].deploymentId);
                    }
                    let param = {
                        templateIds: templateIds,
                        deploymentIds: deploymentIds
                    };
                    Api.deleteVersions(JSON.stringify(param), response => {
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            this.deleteLoading = false;
                            return;
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('extendManage/deleteGroupElement', response.data.statusMessage);
                            this.deleteLoading = false;
                            return;
                        }
                        this.deleteLoading = false;
                        this.$message({ showClose: true, message: this.$t('extendCommon.DELETE_SUCCESS'), type: 'success' });
                        this.callbackQuery();
                        this.$emit('callbackQuery');
                    });
                })
                .catch(() => {
                    this.deleteLoading = false;
                });
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.btnQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.btnQuery();
        },
        // 查询数据
        queryPageList() {
            this.currentPage = 1;
            this.btnQuery();
        },
        // 回调查询
        callbackQuery() {
            this.currentPage = 1;
            this.btnQuery();
        },
        // 查询数据
        btnQuery() {
            var param = {
                description: this.versionForm.description,
                templateKey: this.row.templateKey,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            Api.queryAllTemplates(JSON.stringify(param), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('templateManage/queryAllTemplates', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('templateManage/queryAllTemplates', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
            });
        },
        changeVerDialogColse: function() {
            this.$emit('changeVerDialogColse');
            this.$emit('btnQuery');
            this.changeVerDialogVisible = false;
        }
    }
};
</script>
<style></style>
